import {FC, ReactNode} from 'react';
import {Outlet, useLocation} from 'react-router-dom';

import Header from './Header';
import DownloadMobileApp from '../DownloadMobileApp';
import styles from './Layout.module.scss';
import Sidebar from './Sidebar';

import {useMobileDetect} from '../../hooks/useMobileDetect';

interface ILayout {
  children?: ReactNode;
}

const Layout: FC<ILayout> = ({children}) => {
  const {isMobile} = useMobileDetect();

  if (isMobile()) {
    return <DownloadMobileApp />;
  }

  return (
    <div className={styles.layout}>
      <Header />
      <Sidebar />
      <main className={styles.contentWrapper}>{children ? children : <Outlet />}</main>
    </div>
  );
};

export default Layout;
